import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {loadClubs} from "./asyncActions";
import {Club} from "../../../api/ClubService";

interface State {
    allClubs: Club[]
    selectedClub?: Club
}

const initialState: State = {
    allClubs: [],
};

export interface LoadClubsActionPayload {
    clubs?: Club[]
    selectedClub?: Club
}

let clubSelectionSlice = createSlice(
    {
        name: "Clubs",
        initialState: initialState,
        reducers: {
            handleReset: (state) => {
                state.allClubs = []
                state.selectedClub = undefined
            },
            handleClubChange: (state, action: PayloadAction<string | undefined>) => {
                let clubId = action.payload

                if (!clubId) {
                    return state;
                }

                const selectedClub = state.allClubs
                    .find((item) => item.id === clubId);
                if (!selectedClub) {
                    return;
                }

                state.selectedClub = selectedClub
            },
        },
        extraReducers: (builder) => {
            builder.addCase(
                loadClubs.fulfilled,
                (state, action: PayloadAction<LoadClubsActionPayload>) => {
                    if (action.payload.clubs) {
                        state.allClubs = action.payload.clubs
                    }
                    if (action.payload.selectedClub) {
                        state.selectedClub = action.payload.selectedClub
                    }
                }
            )
        }
    }
);

export const {
    handleReset,
    handleClubChange
} = clubSelectionSlice.actions;

export default clubSelectionSlice.reducer;